<template>
	<field
			margin="0"
			padding="0"
			is-off-style
			:dateValue="filterDate"
			@updateTime="onTime($event)"
			@updateToday="onToday"
			is-time
			isOnlyMonthAndYear
	>
	</field>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// helper
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	name: "CalendarHeader",
	props: {
		filterDate: String
	},
	data: () => ({
		value: getDefaultDate(1)
	}),
	methods: {
		...mapActions([ 'getCalendarOnDate' ]),
		onTime(date) {
			this.$emit('updateTime', date);
		},
		async onToday() {
			this.$emit('updateToday');
		}
	}
};
</script>

<style scoped lang="scss">
@import "calendarHeader";
</style>
